{
  "version": 1,
  "asset_id": "bc24aca0-8db3-4244-b90e-5212716823d7",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/bc24aca0-8db3-4244-b90e-5212716823d7/beverly-hills-shingle-roof-tear-off-1280w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/bc24aca0-8db3-4244-b90e-5212716823d7/beverly-hills-shingle-roof-tear-off-1280w.avif",
  "original_filename": "beverly-hills-shingle-roof-tear-off-1280w.avif",
  "size": 113545,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:41Z"
}
